import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';
import { PopoverPosition } from '@shared/components/popover/popover.types';

@Component({
  selector: 'cx-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
  imports: [CommonModule],
})
export class PopoverComponent {
  @Input({ required: true }) content!: string | TemplateRef<HTMLElement>;
  @Input() position: PopoverPosition = 'bottom-left';
  @Input() arrow = false;

  get isTemplate(): boolean {
    return this.content instanceof TemplateRef;
  }

  get template(): TemplateRef<HTMLElement> | null {
    if (this.content instanceof TemplateRef) {
      return this.content;
    }
    return null;
  }
}
